import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "select",
    "productCard",
    "productCarousel",
    "productCardDivider",
    "discountCodeDivider",
    "discountCode",
    "contentInput",
    "authorInput",
    "previewMessage",
    "previewAuthor",
    "previewRich"
  ]

  connect() {
    this.swap()
    this.refreshPreview()
  }

  swap() {
    const type = this.hasSelectTarget ? this.selectTarget.value : 'none'
    this.toggleTargets(type)
    this.updateRichPreview(type)
  }

  refreshPreview() {
    const presence = (value) => (value && value.trim().length > 0 ? value : null)

    const message = this.hasContentInputTarget ? presence(this.contentInputTarget.value) : null
    const author = this.hasAuthorInputTarget ? presence(this.authorInputTarget.value) : null

    if (this.hasPreviewMessageTarget) {
      this.previewMessageTarget.textContent = message || 'Message preview will appear here as you type.'
    }

    if (this.hasPreviewAuthorTarget) {
      this.previewAuthorTarget.textContent = author || 'Sales Assistant'
    }
  }

  toggleTargets(type) {
    const showProduct = type === 'product_card'
    const showDiscount = type === 'discount_code'
    const showCarousel = type === 'product_carousel'

    this.toggleVisibility(this.hasProductCardTarget ? this.productCardTarget : null, showProduct)
    this.toggleVisibility(this.hasProductCardDividerTarget ? this.productCardDividerTarget : null, showProduct)
    this.toggleVisibility(this.hasProductCarouselTarget ? this.productCarouselTarget : null, showCarousel)
    this.toggleVisibility(this.hasDiscountCodeTarget ? this.discountCodeTarget : null, showDiscount)
    this.toggleVisibility(this.hasDiscountCodeDividerTarget ? this.discountCodeDividerTarget : null, showDiscount)
  }

  toggleVisibility(element, visible) {
    if (!element) return

    element.classList.toggle('hidden', !visible)
    element.toggleAttribute('hidden', !visible)
    element.style.display = visible ? '' : 'none'
  }

  updateRichPreview(type) {
    if (!this.hasPreviewRichTarget) return

    let copy = 'Rich content disabled for this campaign.'

    if (type === 'product_card') {
      copy = 'Displays a product card with title, description, pricing and an Add to Cart CTA.'
    } else if (type === 'discount_code') {
      copy = 'Displays a discount code tile with copy-to-clipboard CTA.'
    }

    this.previewRichTarget.textContent = copy
  }
}
